<template>
    <div class="calendar__desktop">
        <div class="calendar__b-controls">
            <calendar-toggle></calendar-toggle>
            <calendar-time-periods></calendar-time-periods>
        </div>
        <div class="calendar__d-calendar d-calendar">
            <calendar-time></calendar-time>
            <div class="d-calendar__body">
                <calendar-week></calendar-week>
                <calendar-cells></calendar-cells>
            </div>
        </div>
    </div>
</template>

<script>
    import CalendarWeek from "./CalendarWeek.vue";
	import CalendarTime from "./CalendarTime.vue";
	import CalendarCells from "./CalendarCells.vue";
	import CalendarTimePeriods from "./CalendarTimePeriods.vue";
    import CalendarToggle from "../CalendarToggle";

    export default {
		name: 'CalendarDesktop',
        components: {
			CalendarTimePeriods,
			CalendarCells,
			CalendarTime,
			CalendarWeek,
            CalendarToggle
        },
    }
</script>


